import { Agent } from "@zapier/canvas-state";
import { AvatarGrid, PuzzleAvatar } from "./PuzzleAvatar";
import { AssetIcon } from "../AssetIcon";

interface BotAvatarProps {
  agentAvatar: Agent["avatar"];
  size?: number;
}

/**
 * BotAvatar component for displaying agent avatars
 * Uses PuzzleAvatar for agents with puzzle avatar data
 * Falls back to an AssetIcon when no avatar grid is available
 */
export const BotAvatar = ({ agentAvatar, size = 15 }: BotAvatarProps) => {
  // Only render a puzzle avatar when **both** the grid pattern and color are present.
  // This mirrors the Agent repo's approach of ensuring all required fields exist before rendering.
  if (agentAvatar?.grid && agentAvatar?.color) {
    return (
      <PuzzleAvatar
        grid={agentAvatar.grid as AvatarGrid}
        color={agentAvatar.color}
        size={size}
      />
    );
  }

  // Fallback: show default asset icon
  return <AssetIcon iconName="navCentral" />;
};
